import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LanguageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"language"}/>
}
